import { fromDTO as availableCreditFromDTO, sumCredits } from "../available-credit";
import { fromResponseDTO } from "../manual-service-billing";
export function fromDTO(dto) {
  const credits = dto.credits.map(availableCreditFromDTO);
  return {
    manualServices: fromResponseDTO(dto.manualServices),
    credits,
    totalCredits: sumCredits(credits)
  };
}